/**
 * @deprecated Used only by migrated sf components
 */
export const sizes = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
  xl3: 'xl3',
  xl4: 'xl4',
};
/**
 * @deprecated Used only by migrated sf components
 */
export const typographySizes = {
  'extra-small': 'extra-small',
  small: 'small',
  regular: 'regular',
  big: 'big',
};
/**
 * @deprecated Used only by migrated sf components
 */
export const sizesValues = Object.values(sizes);
/**
 * @deprecated Used only by migrated sf components
 */
export default sizes;
